// extracted by mini-css-extract-plugin
export default {"button--pending":"bookmark_button--pending__f4rAg"};